import { Component, Element, Host, Prop, State, h } from '@stencil/core';

@Component({
  tag: 'lgr-expandable-area',
  styleUrl: 'expandableArea.scss',
  shadow: true,
})

export class ExpandableArea {

  @Element() el!: HTMLLgrExpandableAreaElement;
  /**
   * Height of visible collapsed area
   */
  @Prop() contentHeight: string = "116";
  
  @State() expanded: boolean = false;
  
  private cards!: HTMLSlotElement;

  componentDidLoad() {
    this.cards = this.el.querySelector('[slot="cards"]') as HTMLSlotElement;
  }

  render() {

    return (
      <Host>
        <div
          class="lgr-expandable-area"
          style={{"max-height": this.expanded ? `${this.cards.offsetHeight}px` : `${this.contentHeight}px`}}
        >
          <div>
            <slot name="cards"></slot>
          </div>
          <button
            class={{
              "lgr-expandable-area-button": true,
              "lgr-expandable-area-button-open": this.expanded
            }}
            onClick={this.areaExpanded}
          >
            <lgr-icon>expand_more</lgr-icon>
          </button>
        </div>

      </Host>
    );
  }

  private areaExpanded = () => {
    this.expanded = !this.expanded;
  }
}
